import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SeoHead() {
  const location = useLocation();

  useEffect(() => {
    const canonical = `https://www.luobotv.com${location.pathname}`;

    // Update canonical
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonical;

    // Update og:url
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null;
    if (ogUrl) {
      ogUrl.content = canonical;
    }

    // Update last-modified
    let lastMod = document.querySelector('meta[http-equiv="Last-modified"]') as HTMLMetaElement | null;
    if (!lastMod) {
      lastMod = document.createElement('meta');
      lastMod.httpEquiv = 'Last-modified';
      document.head.appendChild(lastMod);
    }
    lastMod.content = new Date().toUTCString();

    // Update document title based on path
    let title: string;
    if (location.pathname === '/') {
      title = '萝卜影视-电视剧全集与连续剧完整版 | 电视剧大结局 | 电视剧在线全集';
    } else if (location.pathname === '/about') {
      title = '关于萝卜影视 - 品牌介绍与联系我们';
    } else if (location.pathname.startsWith('/category/')) {
      title = '电视剧分类 - 萝卜影视';
    } else if (location.pathname.startsWith('/drama/')) {
      title = '电视剧详情 - 萝卜影视';
    } else {
      title = '萝卜影视-电视剧全集与连续剧完整版 | 电视剧大结局 | 电视剧在线全集';
    }
    document.title = title;

    return () => {
      // no cleanup needed
    };
  }, [location.pathname]);

  return null;
}